<template>
    <div class="standalone-layout">
        <div class="standalone-content">
            <router-view />
        </div>
    </div>
</template>

<script>
export default {
    name: 'StandaloneLayout'
}
</script>

<style scoped>
.standalone-layout {
    min-height: 100vh;
    background-color: #f8f9fa;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 2rem;
}

.standalone-content {
    width: 100%;
    max-width: 800px;
    padding: 1rem;
}
</style>
